import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Lightweight from '../views/Lightweight.vue'
import BrickMortar from '../views/BrickMortar.vue'
import ThankYou from '../components/ThankYou.vue'
const routes = [

  {
    path: '/',
    name: 'Home',
    component: Home,
    props: route => ({ url_slug: (route.query?.q) ? route.query.q : 'tim-test' })
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/thank-you',
    name: 'ThankYou',
    component: ThankYou
  },
  {
    path: '/standard',
    name: 'Brickandmortar',
    component: BrickMortar,
  },
  {
    path: '/lightweight',
    name: 'lightweight',
    component:  Lightweight
  }

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
